import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { Client } from './client';
import { ClientsService } from './clients.service';

@Component({
  selector: 'app-client',
  templateUrl: './client.component.html',
  styleUrls: ['./client.component.css']
})
export class ClientComponent implements OnInit {

	clients: Client[];
	hide = {};
	newName = '';
	changed = false;
	locked = false;

	constructor(
		private _clients: ClientsService,
		private _snack: MatSnackBar,
		@Inject(MAT_DIALOG_DATA) public telNumber: string,
	) {
		
	}

	addName() {
		if (this.locked) return;
		const n = this.newName;
		this.newName = ''; // clear it out... 
		

		if (n) {
			this.locked = true;
			this._clients.addName(n, this.telNumber)
				.subscribe(
					resp => {
						if (!this.clients.find(c => c === resp)) {
							this.clients.push(resp);
						}
						this.changed = true;
						this.locked = false;
					},
					err => {
						console.warn(err);
						this.locked = false;
					})
		}
	}

	ngOnInit() {
		this.clients = this._clients.getByPhone(this.telNumber)
	}

	// insert()

	update(client: Client, value: string) {
		const onError = (err?: any) => {
			console.warn(err);
			this._snack.open('There was a problem renaming the client');
		}
		this._clients.rename(client, value)
			.subscribe(
				resp => {
					if (!resp.keys || !resp.keys.length || resp.keys.length !== 1) {
						onError(resp);
					} else {
						this.changed = true;
					}
				},
				err => onError(err)
			)
	}

	remove(client: Client) {
		const onError = (err?: any) => {
			this._snack.open('There was a problem removing the client');
			this.hide[client.id] = false;
		}
		this.hide[client.id] = true;
		this._clients.disassociate(client)
			.subscribe(
				resp => {
					if (!resp.keys || !resp.keys.length || resp.keys.length !== 1) {
						onError(resp);
					} else {
						this.changed = true;
					}
				},
				err => onError(err))
	}

}
